import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { ReactActionDialogBodyProps } from '~commonInfra/dialogs/ReactActionDialog';
import { cssClass } from '~src/style';

import { SettingsStyles } from '../../../styles/CommonStyles';


export type PropsForGenerateNodeScriptDialogDialog = ReactActionDialogBodyProps<
  GenerateNodeScriptDialogProps,
  GenerateNodeScriptDialogState
>;

export type GenerateNodeScriptDialogProps = Readonly<{
  description: string;
  cammandLine1: string;
  cammandLine2: string;
  cammandLine3: string;
  cammandLine4: string;
  cammandLine5: string;
}>

export type GenerateNodeScriptDialogState = Readonly<{
  hasError: boolean;
}>

export function GenerateNodeScriptDialogBody(props: PropsForGenerateNodeScriptDialogDialog) {

  const descriptionDivClassName = `${SettingsStyles.settingsGroupDescription}`;

  return (
    <div className={fieldClass}>
      <div className={descriptionDivClassName}
                data-tb-test-id={'pool-name-text-details'}>
                <span>
                  {props.description}
                </span>
                <span className={cammandLIneClass}>
                  {props.cammandLine1}
                </span>
                <span className={cammandLIneClass}>
                  {props.cammandLine2}
                </span>
                <span className={cammandLIneClass}>
                  {props.cammandLine3}
                </span>
                <span className={cammandLIneClass}>
                  {props.cammandLine4}
                </span>
                <span className={cammandLIneClass}>
                  {props.cammandLine5}
                </span>
      </div>
    </div>
  );
}

const fieldClass = style({ marginBottom: TabStyles.Sizing.BaseUnit * 5 });

const cammandLIneClass = style({ marginTop: 10, display: 'block', fontWeight: 'bold' });


const textFieldClass = cssClass('edit-pool-dialog', 'field', {
  width: '100%'
});

export const errorClass = style({ marginTop: TabStyles.Spacing.DefaultSpace, color: TabStyles.Colors.AttentionDark });

